const INITIAL_STATE_FORMS = {
    isOpen: false, 
    title: '', 
    typeModal: -1
}

const INITIAL_STATE_CENTRALIZEDMODAL = {
    isOpen: false,
    title: '',
    componentToShow: '',
    datasComponent: null,
}


export function openModalForms(state = INITIAL_STATE_FORMS, action) {
    switch (action.type) {
        case 'OPEN_MODALFORMS_EDIT' :
            return { isOpen: !state.isOpen, typeModal: 0, title: action.title  }
        case 'OPEN_MODALFORMS_CREATE' :
            return { isOpen: !state.isOpen, typeModal: 1, title: action.title  }
        default :
            return { isOpen: false, typeModal: -1, title: action.title  }
    }
} 


export function openModalCentralized(state = INITIAL_STATE_CENTRALIZEDMODAL, action) {
    switch (action.type) {

        case 'OPEN_CENTRALIZEDMODAL' :
            return { 
                isOpen: !state.isOpen, 
                title: action.title, 
                componentToShow: action.componentToShow, 
                datasComponent: action.datasComponent 
            }

        case 'CLOSE_CENTRALIZEDMODAL' :
            return { isOpen: !state.isOpen, title: action.title }
            
        default :
            return { isOpen: false, title: action.title  }
    }
}